import React from "react";

import { Hero } from "@/components/Hero";
import { Banner } from "@/components/Banner";
import { BannerWrapperSize } from "@/components/Banner/types";
import { billboardProps } from "@/data/types/home";

import "./styles.scss";

const HOME_HERO_IMAGE = "/images/hero-banner.webp";
const LANDING_HERO_IMAGE = "/images/landing-banner.webp";

export const HeroModule = ({
  data,
  wrapperSize,
  variant,
}: {
  data: billboardProps;
  wrapperSize?: BannerWrapperSize;
  /**
   * `home` renders the restored Home variant (`/`): `medium` Banner on the
   * `primary-50` background, no chips, and the local `hero-banner.webp`.
   * Omitted renders the redesigned variant used by `/qr-code-generator` and
   * landings. See docs/HOME.md.
   */
  variant?: "home";
}) => {
  const {
    ctaLabel,
    ctaLink,
    richtext,
    data_qa,
    backgroundColor,
    ctaStyle,
    twoColumns,
    image,
    chips,
  } = data;

  //Differentiate between home and landing sem
  const isHome = variant === "home";

  return (
    <Banner
      light
      medium={isHome}
      withoutPadding={!isHome}
      customBgColor={backgroundColor ?? (isHome ? "primary-50" : "neutral-white")}
      customClass={isHome ? undefined : "hero-module__banner"}
      wrapperSize={wrapperSize}
      data-testid="hero-module"
    >
      <Hero
        variant={isHome ? "home" : undefined}
        priority
        heroText={richtext}
        cta={{
          ctaLink,
          ctaLabel,
          data_qa,
          ctaStyle,
        }}
        chips={isHome ? undefined : chips}
        twoColumns={twoColumns}
        img={isHome ? HOME_HERO_IMAGE : (image ?? LANDING_HERO_IMAGE)}
        size="(max-width: 768px) 640px, 633px"
        quality={75}
        unoptimized={false}
        fetchPriority="high"
      />
    </Banner>
  );
};
